import { Axios } from 'axios';

export class ActivityCgiBinding {
  constructor(private readonly httpClient: Axios) {}

  /***
   * 查询当前活动的静态信息，如开始结束时间
   * @param activityId
   */
  getActivityDetail(activityId: string) {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 6,
      actid: activityId,
    });
  }

  /***
   * 查询当前用户的活动参加状态
   * @param ruleTag
   */
  queryUserActivityState(activityId: string) {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 8,
      actid: activityId,
    });
  }

  /***
   * 使用activityId检查用户是否符合发奖前置条件
   * @param activityId
   * @param remark
   */
  preCheckCurrentUser(activityId: string, remark?: any) {
    return this.httpClient.post('activity/activitylogin.fcgi', {
      action: 2,
      actid: activityId,
      remark,
    });
  }

  /***
   * 发放奖品给用户
   * @param activityId
   */
  sendRewardToUser(activityId: string) {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 3,
      actid: activityId,
    });
  }

  /***
   * 获取用户已经领取的奖品列表
   * @param activityId
   */
  getUserRewardList(activityId: string) {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 1,
      actid: activityId,
    });
  }

  /***
   * 获取用户已经领取的奖品列表
   * @param activityId
   */
  getUserRewardListByTag(tag: string) {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 1,
      rule_tag: tag,
    });
  }

  getUserInfo() {
    return this.httpClient.post('userinfo.fcgi', {
      detail: 1,
    });
  }

  /*---------- 不需要act_id的接口---------------*/
  /**
   * 获取活动信息，不需传act_id
   */
  getActivityInfo() {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 6,
      act_no: 1,
    });
  }

  /**
   * 查询用户领奖情况
   */
  beforeGetReward() {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 8,
      rule_tag: 106,
      detail: 1,
    });
  }

  /**
   * 领取奖励
   */
  getReward() {
    return this.httpClient.post('activity/activityreward.fcgi', {
      action: 7,
      act_no: 1,
      rule_tag: 106,
    });
  }
}
